export default __webpack_public_path__ + "static/media/man.7dcddb8e.jpg";